import { msg } from 'gt-react';
import { MagnifyingGlassIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';

const SearchTransactionsPage = lazyRouteComponent(
  () => import('./SearchTransactionsPage'),
  'SearchTransactionsPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/search-transactions',
  validateSearch: z.object({
    divisions: z.array(z.string()).optional(),
    branches: z.array(z.string()).optional(),
    suppliers: z.array(z.string()).optional(),
    customer: z.string().optional(),
    invoiceNo: z.string().optional(),
    orderLineNo: z.string().optional(),
    productCode: z.string().optional(),
    supplierContractNo: z.string().optional(),
  }),
  staticData: {
    app: {
      nav: {
        label: msg('Search Transactions', {
          context: 'sidebar nav label, Ship and Debit section',
        }),
        icon: <MagnifyingGlassIcon className="h-4 w-4" weight="fill" />,
        group: 'Ship and Debit',
        order: 17,
      },
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.SDTransaction },
        ],
      },
    },
  },
  component: SearchTransactionsPage,
  loader: () => ({
    crumb: msg('Search Transactions', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.SDTransaction,
    });
  },
});
